import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import clasnames from 'classnames';
import Route from '../../Route';
import RawLink from '../../RawLink';

var TabsHeader = function TabsHeader(props) {
  var items = props.items;

  var _renderItem = function _renderItem(_ref) {
    var key = _ref.key,
        title = _ref.title,
        route = _ref.route;
    var path = route.path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');

    var _route = _objectSpread(_objectSpread({}, route), {}, {
      path: path
    });

    return React.createElement(Route, Object.assign({}, _route, {
      key: key
    }), function (_ref2) {
      var match = _ref2.match;
      var isActive = !!match;
      var classNames = clasnames('TabsHeader__item', {
        'TabsHeader__item--active': isActive
      });
      return React.createElement("li", {
        className: classNames,
        role: "tab"
      }, React.createElement(RawLink, {
        className: "TabsHeader__item-link",
        to: route.path
      }, title));
    });
  };

  return React.createElement("div", {
    className: "TabsHeader"
  }, React.createElement("ul", {
    className: "TabsHeader__nav",
    role: "tablist"
  }, items.map(_renderItem)));
};

TabsHeader.displayName = 'RouterTabs.Header';
export default TabsHeader;